import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

let headerScrollTrigger = null

export default function initHeader() {

    const siteHeader = document.querySelector('.site-header')

    if (!siteHeader) return

    siteHeader.classList.remove('is-scrolled')

    // Kill old triggers if they exist
    headerScrollTrigger?.kill()

    headerScrollTrigger = ScrollTrigger.create({
        trigger: 'body',
        start: "top+=40px top",
        end: "bottom bottom-=100px",
        toggleClass: {
            targets: siteHeader,
            className: 'is-scrolled'
        },
    })

}
